module.exports = __webpack_public_path__ + "img/imgXharra-3.dcc6494b.png";